import * as individualData from "./core/components/individualData.js"
import * as documents from "./documents/documents.js"
import * as machineSkills from "./machine/machineSkills.js"
import * as geocode from "./geomap/geocode/geocode.js"
import * as logs from "./core/components/logs.js"
import * as contactPersons from "./address/contactPersons.js"
import * as addressAllocations from "./address/allocations.js"
import * as allocations from "./machine/allocations.js"
import * as teamsMailSelector from "./core/components/teamsMailSelector.js"
import * as profilePictureSelector from "./userSettings/profilePictureSelector.js"
import * as vacation from "./resource/vacation.js"
import * as calcPriceField from "./parts/calcPriceField.js"
import * as unitSearchBox from "./core/components/unitSearchBox.js"
import * as partsCSGrid from "./parts/partsCSGrid.js"
import * as editAssemblyGroup from "./parts/editAssemblyGroup.js"
import * as simpleLabel from "./core/components/simpleLabel.js"
import * as groupingTextBox from "./core/components/groupingTextBox.js"
import * as flagSelection from "./core/components/flagSelection.js"
import * as iconSelection from "./core/components/iconSelection.js"
import * as resourcePlanningExpenses from "./resourcePlanning/resourcePlanningExpenses.js"
import * as resourcePlanningHourlyRate from "./resourcePlanning/resourcePlanningHourlyRate.js"
import * as definedMachinesGrid from "./machine/definedMachinesGrid.js"
import * as resourcePlanningMaterial from "./resourcePlanning/resourcePlanningMaterial.js"
import * as reporting from "./core/components/reporting.js"
import * as multiselect from "./assignmentDistribution/forms/multiselect.js"
import * as previewGrid from "./assignmentDistribution/forms/previewGrid.js"
import * as projectMachines from "./project/projectMachines.js"
import * as projectMaterial from "./project/projectMaterial.js"
import * as projectContactPersons from "./project/projectContactPersons.js"
import * as projectContacts from "./project/projectContacts.js"
import * as addressContacts from "./project/addressContacts.js"
import * as processDiagram from "./core/components/processDiagram.js"
import * as projectAssignments from "./project/projectAssignments.js"
import * as serviceReportCompletionGrid from "./serviceReport/serviceReportCompletionGrid.js"
import * as serviceReportAccountAssignmentTab from "./serviceReport/ServiceReportAccountAssignmentTab.js"
import * as editReportQuestions from "./editReport/editReportQuestions.js"
import * as service_report_editor from "./statistics/service_report/service_report_editor.js"
import { registerModule } from "./core/moduleRegister.js"
import *  as crTemplateQRAGrid from "./reportMetaData/crTemplateQRAGrid.js"
import *  as ticketMaterial from "./ticket/ticketMaterial.js"
import *  as editTicketMachines from "./ticket/editTicketMachines.js"
import *  as ticketAllocations from "./ticket/ticketAllocations.js"
import *  as ticketHistory from "./ticket/ticketHistory.js"
import *  as ticketLevelGrid from "./sla/ticketLevel/ticketLevelGrid.js"
import *  as serviceHoursPosGrid from "./sla/serviceHours/serviceHoursPosGrid.js"
import *  as timeZoneInfoBox from "./sla/agreement/timeZoneInfoBox.js"
import *  as fieldComment from "./sla/fieldComment.js"
import *  as agreementLevelGrid from "./sla/agreement/agreementLevelGrid.js"
import *  as agreementMachineGrid from "./sla/agreement/agreementMachineGrid.js"
import *  as tempDescription from "./serverTemplate/tempDescription.js"
import *  as InheritedValueComment from "./tasks/InheritedValueComment.js"
import *  as recurrenceSchema from "./tasks/recurringTask/recurrenceSchema.js"
import *  as workPackageCapacityRequimentsGrid from "./tasks/workPackage/workPackageCapacityRequimentsGrid.js"
import *  as workPackageReportsGrid from "./tasks/workPackage/workPackageReportsGrid.js"
import *  as checkAppServerButton from "./generalSettings/general/checkAppServerButton.js"
import *  as editCalendarGrid from "./generalSettings/general/editCalendarGrid.js"
import *  as dateExample from "./reportMetaData/dateExample.js"
import *  as languageManagement from "./generalSettings/general/languageManagement.js"
import *  as checkIfReachableTextBox from "./innobot/checkIfReachableTextBox.js"
import *  as editIdentifierGrid from "./generalSettings/resourcePlanning/editIdentifierGrid.js"
import *  as editGeneralGroupGrid from "./generalSettings/resourcePlanning/editGeneralGroupGrid.js"
import *  as editVehicles from "./generalSettings/assigment/editVehicles.js"
import *  as editSendStatus from "./generalSettings/resourcePlanning/editSendStatus.js"
import *  as flagsGrid from "./generalSettings/flags/flagsGrid.js"
import *  as iconsGrid from "./generalSettings/icons/iconsGrid.js"
import *  as pushNotificationsStateGrid from "./generalSettings/resourcePlanning/pushNotificationsStateGrid.js"
import *  as favoriteFilterGrid from "./generalSettings/favoriteFilter/favoriteFilterGrid.js"
import *  as kendoTemplatesGrid from "./generalSettings/resourcePlanning/kendoTemplatesGrid.js"
import *  as lookupsGrid from "./generalSettings/resourcePlanning/lookupsGrid.js"
import *  as editProjectStatus from "./generalSettings/project/editProjectStatus.js"
import *  as editProjectType from "./generalSettings/project/editProjectType.js"
import *  as weekendSchemaGrid from "./generalSettings/resource/weekendSchemaGrid.js"
import *  as editSuccursales from "./generalSettings/resource/editSuccursales.js"
import *  as editDocumentCategoriesGrid from "./generalSettings/documents/editDocumentCategoriesGrid.js"
import *  as editDocumentSubCategoriesGrid from "./generalSettings/documents/editDocumentSubCategoriesGrid.js"
import *  as editDocumentFolderStructure from "./generalSettings/documents/editDocumentFolderStructure.js"
import *  as notAllowedDocumentTypes from "./generalSettings/documents/notAllowedDocumentTypes.js"
import *  as editMachineTypes from "./generalSettings/machine/EditMachineTypes.js"
import *  as EditMachineMainGroup from "./generalSettings/machine/EditMachineMainGroup.js"
import *  as EditMachineGroup from "./generalSettings/machine/EditMachineGroup.js"
import *  as editStatus from "./generalSettings/machine/editStatus.js"
import *  as editProductGroups from "./generalSettings/parts/editProductGroups.js"
import *  as editTicketTypes from "./generalSettings/tickets/editTicketTypes.js"
import *  as editTicketStatus from "./generalSettings/tickets/editTicketStatus.js"
import *  as editTicketInternalStatus from "./generalSettings/tickets/editTicketInternalStatus.js"
import *  as editTicketUrgency from "./generalSettings/tickets/editTicketUrgency.js"
import *  as editTicketMedium from "./generalSettings/tickets/editTicketMedium.js"
import *  as editNachschlag from "./generalSettings/editNachschlag.js"
import *  as editAdrTypes from "./generalSettings/addresses/editAdrTypes.js"
import *  as editShippingMethods from "./generalSettings/addresses/editShippingMethods.js"
import *  as editFreeOfChargeKey from "./generalSettings/serviceReport/editFreeOfChargeKey.js"
import *  as editTimeTypes from "./generalSettings/serviceReport/editTimeTypes.js"
import *  as editSchemas from "./generalSettings/serviceReport/editSchemas.js"
import *  as travelUnits from "./generalSettings/serviceReport/travelUnits.js"
import *  as editCashExpense from "./generalSettings/serviceReport/editCashExpense.js"
import *  as units from "./generalSettings/unit/units.js"
import *  as faultCodes from "./generalSettings/faultCodes/faultCodes.js"
import *  as spesenGrid from "./generalSettings/spesen/spesenGrid.js"
import *  as countries from "./generalSettings/countries.js"
import *  as apiKeyBox from "./generalSettings/apiKeyBox.js"
import *  as translationsLink from "./generalSettings/logInSecurity/translationsLink.js"
import *  as editDefaultImage from "./generalSettings/dynamicSearch/editDefaultImage.js"
import *  as editQuanosCatalog from "./generalSettings/quanos/editQuanosCatalog.js"
import *  as skillTreeApp from "./generalSettings/skills/skillTreeApp.js"
import *  as skillGrid from "./generalSettings/skills/skillGrid.js"
import *  as editCurrencies from "./generalSettings/commercial/editCurrencies.js"
import *  as editInternalCurrencies from "./generalSettings/commercial/editInternalCurrencies.js"
import *  as mainGroupCurrencies from "./generalSettings/commercial/mainGroupCurrencies.js"
import *  as editVATRate from "./generalSettings/addresses/editVATRate.js"
import *  as showProtokollUebersicht from "./serverTemplate/showProtokollUebersicht.js"
import *  as groupGrid from "./generalSettings/resourcePlanning/GroupGrid.js"
import *  as editTranslations from "./editIndividualFields/editTranslations.js"
import *  as mainGroupGrid from "./generalSettings/resourcePlanning/MainGroupGrid.js"
import *  as signTextBox from "./generalSettings/resourcePlanning/signTextBox.js"
import *  as editTranslationsReport from "./reportMetaData/editTranslations.js"
import *  as flagResourcesGrid from "./generalSettings/flags/flagResourcesGrid.js"
import *  as flagAssignmentsGrid from "./generalSettings/flags/flagAssignmentsGrid.js"
import *  as affilationsGrid from "./favoriteFilter/affilationsGrid.js"
import *  as editObjectTypes from "./generalSettings/documents/editObjectTypes.js"
import *  as editSchemaContent from "./generalSettings/serviceReport/editSchemaContent.js"
import *  as editLanguageSpecificParameters from "./generalSettings/serviceReport/editLanguageSpecificParameters.js"
import *  as editChars from "./generalSettings/unit/editChars.js"
import *  as userSettingsSelectUser from "./userSettings/userSettingsSelectUser.js"
import *  as assignmentSorting from "./userSettings/assignmentSorting.js"
import *  as rightsSettings from "./userSettings/rightsSettings.js"
import *  as userModuleAllocation from "./userSettings/userModuleAllocation.js"
import *  as editQuanosUserCatalog from "./userSettings/editQuanosUserCatalog.js"
import *  as iframe from "./core/components/iframe.js"
import *  as dynamiciframe from "./core/components/dynamiciframe.js"
import *  as formGeneratorSearchField from "./core/components/formGeneratorSearchField.js"
import *  as translationsEditorView from "./translationsEditor/translationsEditorView.js"
import *  as editStyles from "./style/editStyles.js"
import *  as editLogo from "./style/editLogo.js"
import *  as shortCutInfoText from "./help/shortCutInfoText.js"
import *  as searchGrid from "./reportMetaData/searchGrid.js"
import *  as targetCriteria from "./reportMetaData/targetCriteria.js"
import *  as signatureGrid from "./reportMetaData/signatureGrid.js"
import *  as applicationCriteriaGrid from "./reportMetaData/applicationCriteriaGrid.js"
import *  as valueGrid from "./reportMetaData/valueGrid.js"
import *  as reportFiles from "./reportMetaData/reportFiles.js"
import *  as attachtedEntityTypes from "./reportMetaData/attachtedEntityTypes.js"
import *  as fileNameAndDocumentTitleDefaultSql from "./reportMetaData/fileNameAndDocumentTitleDefaultSql.js"
import *  as templateSearch from "./reportMetaData/templateSearch.js"
import *  as roleDropDown from "./reportMetaData/roleDropDown.js"
import *  as sqlGeneratorButton from "./reportMetaData/sqlGeneratorButton.js"
import *  as emailSelector from "./email/emailSelector.js"
import *  as attachments from "./email/attachments.js"
import *  as dataGrid from "./email/template/dataGrid.js"
import *  as sqlLabel from "./email/sqlLabel.js"
import *  as staticEmails from "./email/template/staticEmails.js"
import *  as staticDocs from "./email/template/staticDocs.js"
import *  as dataSourceEditor from "./email/dataSource/dataSourceEditor.js"
import *  as dataSourceDetails from "./email/dataSource/dataSourceDetails.js"
import *  as emailEditor from "./email/emailEditor.js"
import *  as serverLog from "./serverProtokoll/serverLog.js"
import *  as serverTemplateFile from "./serverJob/serverTemplateFile.js"
import *  as individualFieldsGrids from "./editIndividualFields/individualFieldsGrids.js"
import *  as editCategories from "./editIndividualCategories/editCategories.js"
import *  as editCategorieFields from "./editIndividualCategories/editCategorieFields.js"
import *  as editDataType from "./editIndividualFields/editDataType.js"
import *  as editLenght from "./editIndividualFields/editLenght.js"
import *  as editDefaultValue from "./editIndividualFields/editDefaultValue.js"
import *  as editLookUpTable from "./editIndividualFields/editLookUpTable.js"
import *  as editIndividualFielsInfo from "./editIndividualFields/info.js"
import *  as editIndividualFieldsStupidSQL from "./editIndividualFields/stupidSQL.js"
import *  as slotDebugInfo from "./core/components/slotDebugInfo.js"
import *  as quickInfo from "./core/components/quickInfo.js"
import *  as recordRightInfo from "./core/components/recordRightInfo.js"
import *  as linkedTasks from "./resourcePlanning/linkedTasks.js"
import *  as calcPriceFieldOrigin from "./editArticle/calcPriceFieldOrigin.js"
import *  as baseDataTreeStructure from "./core/components/baseDataTreeStructure.js"
import *  as gmEmbedApi from "./core/components/gmEmbedApi.js"
import *  as ticketText from "./ticket/ticketText.js"
import *  as repetitionInfo from "./createMultipleAssignments/repetitionInfo.js"
import *  as assignmentPeriodPreview from "./createMultipleAssignments/assignmentPeriodPreview.js"
import * as smartSearch from "./smartSearch/smartSearch.js";
import Warehouses from "./address/warehouses.js"
import OutgoingGoods from "./project/outgoingGoods.js"
import AssignTo from "./ticket/assignTo.js"
import AssignToMe from "./ticket/assignToMe.js"
import ContainerSelection from "./createMultipleAssignments/containerSelection.js"
import Branches from "./generalSettings/addresses/branches"
import NewPasswordTextBox from "./userSettings/newPasswordTextBox.js"
import IngridRights from "./userSettings/userConfig/maingroupRights.js"
import CodeRights from "./userSettings/userConfig/codeRights.js"
import ProjectPlan from "./userSettings/userConfig/projectPlan.js"
import Dashboard from "./generalSettings/dashboard.js"
import * as DashboardConfig from "./dashboard/config/dashboardConfig.js"
import * as FavoriteFilterOnlyStart from "./favoriteFilter/onlyStart.js"
import * as favoriteFilterMultiselect from "./favoriteFilter/favoriteFilterMultiselect.js"
import * as containerFilterDropDown from "./favoriteFilter/containerFilterDropDown.js"
import * as serviceReportListStates from "./serviceReportList/serviceReportListStates.js"
import * as serviceReportListGrid from "./serviceReportList/serviceReportListGrid.js"
import * as DatasourceParameters from "./email/dataSource/parameters.js"
import * as translationLink from "./crReport/translationLink.js"
import * as possibleValuesGrid from "./crReport/possibleValuesGrid.js"
import * as crTagsGrid from "./crReport/crTagsGrid.js"
import * as nuKreisIdGrid from "./nukreis/nuKreisIdGrid.js"
import editDokuKatPermission from "./generalSettings/documents/editDokuKatPermission.js"
import * as skippedTasksGrid from "./tasks/recurringTask/skippedTasksGrid.js"
import *  as titleText from "./core/components/titleText.js";
import * as usableParameters from './reportMetaData/usableParameters';
import PageBox from './reportMetaData/pageBox';
import * as eventManager from "../siteManagement/eventManager.js";
import * as projectComboSearch from "./resourcePlanningPM/projectComboSearch.js"
//
//Alle Module registrieren, damit diese von dynamic.tsx per Namen geladen werden k�nnen. Der Name steht in den JSON Dateien.
export function registerKnownModules() {
    registerModule('app/core/components/titleText', titleText);
    registerModule('app/tasks/recurringTask/skippedTasksGrid', skippedTasksGrid);
    registerModule('app/generalSettings/documents/editDokuKatPermission', editDokuKatPermission );
    registerModule('app/crReport/crTagsGrid', crTagsGrid);
    registerModule('app/crReport/possibleValuesGrid', possibleValuesGrid);
    registerModule('app/crReport/translationLink', translationLink);
    registerModule('app/email/dataSource/parameters', DatasourceParameters);
    registerModule('app/serviceReportList/serviceReportListGrid', serviceReportListGrid);
    registerModule('app/serviceReportList/serviceReportListStates', serviceReportListStates);
    registerModule('app/favoriteFilter/containerFilterDropDown', containerFilterDropDown);
    registerModule('app/favoriteFilter/favoriteFilterMultiselect', favoriteFilterMultiselect);
    registerModule('app/favoriteFilter/onlyStart', FavoriteFilterOnlyStart);
    registerModule('app/dashboard/config/dashboardConfig', DashboardConfig);
    registerModule('app/createMultipleAssignments/assignmentPeriodPreview', assignmentPeriodPreview);
    registerModule('app/createMultipleAssignments/repetitionInfo', repetitionInfo);
    registerModule('app/ticket/ticketText', ticketText);
    registerModule('app/core/components/gmEmbedApi', gmEmbedApi);
    registerModule('app/core/components/baseDataTreeStructure', baseDataTreeStructure);
    registerModule('app/editArticle/calcPriceFieldOrigin', calcPriceFieldOrigin);
    registerModule('app/resourcePlanning/linkedTasks', linkedTasks);
    registerModule('app/core/components/recordRightInfo', recordRightInfo);
    registerModule('app/core/components/quickInfo', quickInfo);
    registerModule('app/core/components/slotDebugInfo', slotDebugInfo);
    registerModule('app/editIndividualFields/editLookUpTable', editLookUpTable);
    registerModule('app/editIndividualFields/editDefaultValue', editDefaultValue);
    registerModule('app/editIndividualFields/editLenght', editLenght);
    registerModule('app/editIndividualFields/editDataType', editDataType);
    registerModule('app/editIndividualCategories/editCategorieFields', editCategorieFields);
    registerModule('app/editIndividualCategories/editCategories', editCategories);
    registerModule('app/editIndividualFields/individualFieldsGrids', individualFieldsGrids);
    registerModule('app/editIndividualFields/info', editIndividualFielsInfo);
    registerModule('app/editIndividualFields/stupidSQL', editIndividualFieldsStupidSQL);
    registerModule('app/serverJob/serverTemplateFile', serverTemplateFile);
    registerModule('app/serverProtokoll/serverLog', serverLog);
    registerModule('app/email/emailEditor', emailEditor);
    registerModule('app/email/dataSource/dataSourceDetails', dataSourceDetails);
    registerModule('app/email/dataSource/dataSourceEditor', dataSourceEditor);
    registerModule('app/email/template/staticDocs', staticDocs);
    registerModule('app/email/template/staticEmails', staticEmails);
    registerModule('app/email/sqlLabel', sqlLabel);
    registerModule('app/email/template/dataGrid', dataGrid);
    registerModule('app/email/attachments', attachments);
    registerModule('app/email/emailSelector', emailSelector);
    registerModule('app/reportMetaData/sqlGeneratorButton', sqlGeneratorButton);
    registerModule('app/reportMetaData/roleDropDown', roleDropDown);
    registerModule('app/reportMetaData/templateSearch', templateSearch);
    registerModule('app/reportMetaData/fileNameAndDocumentTitleDefaultSql', fileNameAndDocumentTitleDefaultSql);
    registerModule('app/reportMetaData/attachtedEntityTypes', attachtedEntityTypes);
    registerModule('app/reportMetaData/reportFiles', reportFiles);
    registerModule('app/reportMetaData/valueGrid', valueGrid);
    registerModule('app/reportMetaData/applicationCriteriaGrid', applicationCriteriaGrid);
    registerModule('app/reportMetaData/signatureGrid', signatureGrid);
    registerModule('app/reportMetaData/targetCriteria', targetCriteria);
    registerModule('app/reportMetaData/searchGrid', searchGrid);
    registerModule('app/help/shortCutInfoText', shortCutInfoText);
    registerModule('app/style/editLogo', editLogo);
    registerModule('app/style/editStyles', editStyles);
    registerModule('app/translationsEditor/translationsEditorView', translationsEditorView);
    registerModule('app/core/components/formGeneratorSearchField', formGeneratorSearchField);
    registerModule('app/core/components/iframe', iframe);
    registerModule('app/core/components/dynamiciframe', dynamiciframe);
    registerModule('app/userSettings/editQuanosUserCatalog', editQuanosUserCatalog);
    registerModule('app/userSettings/userModuleAllocation', userModuleAllocation);
    registerModule('app/userSettings/rightsSettings', rightsSettings);
    registerModule('app/userSettings/assignmentSorting', assignmentSorting);
    registerModule('app/userSettings/userSettingsSelectUser', userSettingsSelectUser);
    registerModule('app/generalSettings/unit/editChars', editChars);
    registerModule('app/generalSettings/serviceReport/editLanguageSpecificParameters', editLanguageSpecificParameters);
    registerModule('app/generalSettings/serviceReport/editSchemaContent', editSchemaContent);
    registerModule('app/generalSettings/documents/editObjectTypes', editObjectTypes);
    registerModule('app/favoriteFilter/affilationsGrid', affilationsGrid);
    registerModule('app/generalSettings/flags/flagAssignmentsGrid', flagAssignmentsGrid);
    registerModule('app/generalSettings/flags/flagResourcesGrid', flagResourcesGrid);
    registerModule('app/reportMetaData/editTranslations', editTranslationsReport);
    registerModule('app/generalSettings/resourcePlanning/signTextBox', signTextBox);
    registerModule('app/generalSettings/resourcePlanning/mainGroupGrid', mainGroupGrid);
    registerModule('app/editIndividualFields/editTranslations', editTranslations);
    registerModule('app/generalSettings/resourcePlanning/groupGrid', groupGrid);
    registerModule('app/serverTemplate/showprotokolluebersicht', showProtokollUebersicht);
    registerModule('app/generalSettings/addresses/editVATRate', editVATRate);
    registerModule('app/generalSettings/commercial/mainGroupCurrencies', mainGroupCurrencies);
    registerModule('app/generalSettings/commercial/editInternalCurrencies', editInternalCurrencies);
    registerModule('app/generalSettings/commercial/editCurrencies', editCurrencies);
    registerModule('app/generalSettings/skills/skillGrid', skillGrid);
    registerModule('app/generalSettings/skills/skillTreeApp', skillTreeApp);
    registerModule('app/generalSettings/quanos/editQuanosCatalog', editQuanosCatalog);
    registerModule('app/generalSettings/dynamicSearch/editDefaultImage', editDefaultImage);
    registerModule('app/generalSettings/logInSecurity/translationsLink', translationsLink);
    registerModule('app/generalSettings/apiKeyBox', apiKeyBox);
    registerModule('app/generalSettings/countries', countries);
    registerModule('app/generalSettings/spesen/spesenGrid', spesenGrid);
    registerModule('app/generalSettings/faultCodes/faultCodes', faultCodes);
    registerModule('app/generalSettings/unit/units', units);
    registerModule('app/generalSettings/serviceReport/editCashExpense', editCashExpense);
    registerModule('app/generalSettings/serviceReport/travelUnits', travelUnits);
    registerModule('app/generalSettings/serviceReport/editSchemas', editSchemas);
    registerModule('app/generalSettings/serviceReport/editTimeTypes', editTimeTypes);
    registerModule('app/generalSettings/serviceReport/editFreeOfChargeKey', editFreeOfChargeKey);
    registerModule('app/generalSettings/addresses/editShippingMethods', editShippingMethods);
    registerModule('app/generalSettings/addresses/editAdrTypes', editAdrTypes);
    registerModule('app/generalSettings/editNachschlag', editNachschlag);
    registerModule('app/generalSettings/tickets/editTicketMedium', editTicketMedium);
    registerModule('app/generalSettings/tickets/editTicketUrgency', editTicketUrgency);
    registerModule('app/generalSettings/tickets/editTicketInternalStatus', editTicketInternalStatus);
    registerModule('app/generalSettings/tickets/editTicketStatus', editTicketStatus);
    registerModule('app/generalSettings/tickets/editTicketTypes', editTicketTypes);
    registerModule('app/generalSettings/parts/editProductGroups', editProductGroups);
    registerModule('app/generalSettings/machine/editStatus', editStatus);
    registerModule('app/generalSettings/machine/editMachineGroup', EditMachineGroup);
    registerModule('app/generalSettings/machine/editMachineMainGroup', EditMachineMainGroup);
    registerModule('app/generalSettings/machine/editMachineTypes', editMachineTypes);
    registerModule('app/generalSettings/documents/notAllowedDocumentTypes', notAllowedDocumentTypes);
    registerModule('app/generalSettings/documents/editDocumentFolderStructure', editDocumentFolderStructure);
    registerModule('app/generalSettings/documents/editDocumentSubCategoriesGrid', editDocumentSubCategoriesGrid);
    registerModule('app/generalSettings/documents/editDocumentCategoriesGrid', editDocumentCategoriesGrid);
    registerModule('app/generalSettings/resource/editSuccursales', editSuccursales);
    registerModule('app/generalSettings/resource/weekendSchemaGrid', weekendSchemaGrid);
    registerModule('app/generalSettings/project/editProjectType', editProjectType);
    registerModule('app/generalSettings/project/editProjectStatus', editProjectStatus);
    registerModule('app/generalSettings/resourcePlanning/lookupsGrid', lookupsGrid);
    registerModule('app/generalSettings/resourcePlanning/kendoTemplatesGrid', kendoTemplatesGrid);
    registerModule('app/generalSettings/favoriteFilter/favoriteFilterGrid', favoriteFilterGrid);
    registerModule('app/generalSettings/resourcePlanning/pushNotificationsStateGrid', pushNotificationsStateGrid);
    registerModule('app/generalSettings/icons/iconsGrid', iconsGrid);
    registerModule('app/generalSettings/flags/flagsGrid', flagsGrid);
    registerModule('app/generalSettings/resourcePlanning/editSendStatus', editSendStatus);
    registerModule('app/generalSettings/assigment/editVehicles', editVehicles);
    registerModule('app/generalSettings/resourcePlanning/editGeneralGroupGrid', editGeneralGroupGrid);
    registerModule('app/generalSettings/resourcePlanning/editIdentifierGrid', editIdentifierGrid);
    registerModule('app/innobot/checkIfReachableTextBox', checkIfReachableTextBox);
    registerModule('app/generalSettings/general/languageManagement', languageManagement);
    registerModule('app/reportMetaData/dateExample', dateExample);
    registerModule('app/generalSettings/general/editCalendarGrid', editCalendarGrid);
    registerModule('app/generalSettings/general/checkAppServerButton', checkAppServerButton);
    registerModule('app/tasks/workPackage/workPackageReportsGrid', workPackageReportsGrid);
    registerModule('app/tasks/workPackage/workPackageCapacityRequimentsGrid', workPackageCapacityRequimentsGrid);
    registerModule('app/tasks/recurringTask/recurrenceSchema', recurrenceSchema);
    registerModule('app/tasks/InheritedValueComment', InheritedValueComment);
    registerModule('app/serverTemplate/tempDescription', tempDescription);
    registerModule('app/sla/agreement/agreementMachineGrid', agreementMachineGrid);
    registerModule('app/sla/agreement/agreementLevelGrid', agreementLevelGrid);
    registerModule('app/sla/fieldComment', fieldComment);
    registerModule('app/sla/agreement/timeZoneInfoBox', timeZoneInfoBox);
    registerModule('app/sla/serviceHours/serviceHoursPosGrid', serviceHoursPosGrid);
    registerModule('app/sla/ticketLevel/ticketLevelGrid', ticketLevelGrid);
    registerModule('app/ticket/ticketHistory', ticketHistory);
    registerModule('app/ticket/ticketAllocations', ticketAllocations);
    registerModule('app/statistics/service_report/service_report_editor', service_report_editor);
    registerModule('app/editReport/editReportQuestions', editReportQuestions);
    registerModule('app/address/allocations', addressAllocations);
    registerModule('app/address/contactPersons', contactPersons);
    registerModule('app/assignmentDistribution/forms/multiselect', multiselect);
    registerModule('app/assignmentDistribution/forms/previewGrid', previewGrid);
    registerModule('app/core/components/flagSelection', flagSelection);
    registerModule('app/core/components/groupingTextBox', groupingTextBox);
    registerModule('app/core/components/iconSelection', iconSelection);
    registerModule('app/core/components/individualData', individualData);
    registerModule('app/core/components/logs', logs);
    registerModule('app/core/components/processDiagram', processDiagram);
    registerModule('app/core/components/reporting', reporting);
    registerModule('app/core/components/simpleLabel', simpleLabel);
    registerModule('app/core/components/teamsMailSelector', teamsMailSelector);
    registerModule('app/core/components/unitSearchBox', unitSearchBox);
    registerModule('app/documents/documents', documents);
    registerModule('app/geomap/geocode/geocode', geocode);
    registerModule('app/machine/allocations', allocations);
    registerModule('app/machine/definedMachinesGrid', definedMachinesGrid);
    registerModule('app/machine/machineSkills', machineSkills);
    registerModule('app/parts/calcPriceField', calcPriceField);
    registerModule('app/parts/editAssemblyGroup', editAssemblyGroup);
    registerModule('app/parts/partsCSGrid', partsCSGrid);
    registerModule('app/project/addressContacts', addressContacts);
    registerModule('app/project/projectAssignments', projectAssignments);
    registerModule('app/project/projectContactPersons', projectContactPersons);
    registerModule('app/project/projectContacts', projectContacts);
    registerModule('app/project/projectMachines', projectMachines);
    registerModule('app/project/projectMaterial', projectMaterial);
    registerModule('app/resource/vacation', vacation);
    registerModule('app/resourcePlanning/resourcePlanningExpenses', resourcePlanningExpenses);
    registerModule('app/resourcePlanning/resourcePlanningHourlyRate', resourcePlanningHourlyRate);
    registerModule('app/resourcePlanning/resourcePlanningMaterial', resourcePlanningMaterial);
    registerModule('app/serviceReport/serviceReportAccountAssignmentTab', serviceReportAccountAssignmentTab);
    registerModule('app/serviceReport/serviceReportCompletionGrid', serviceReportCompletionGrid);
    registerModule('app/userSettings/profilePictureSelector', profilePictureSelector);
    registerModule('app/reportMetaData/crTemplateQRAGrid', crTemplateQRAGrid);
    registerModule('app/ticket/ticketMaterial', ticketMaterial);
    registerModule('app/ticket/editTicketMachines', editTicketMachines);
    registerModule('app/smartSearch/smartSearch', smartSearch);
    registerModule('app/address/warehouses', Warehouses);
    registerModule('app/project/outgoingGoods', OutgoingGoods);
    registerModule('app/ticket/assignTo', AssignTo);
    registerModule('app/ticket/assignToMe', AssignToMe);
    registerModule('app/createMultipleAssignments/containerSelection', ContainerSelection);
    registerModule('app/generalSettings/addresses/branches', Branches);
    registerModule('app/userSettings/newPasswordTextBox', NewPasswordTextBox);
    registerModule('app/userSettings/userConfig/maingroupRights', IngridRights);
    registerModule('app/userSettings/userConfig/codeRights', CodeRights);
    registerModule('app/userSettings/userConfig/projectPlan', ProjectPlan);
    registerModule('app/generalSettings/dashboard', Dashboard);
    registerModule('app/nukreis/nuKreisIdGrid', nuKreisIdGrid);
    registerModule('app/reportMetaData/usableParameters', usableParameters);
    registerModule('app/reportMetaData/pageBox', PageBox)
    registerModule('app/siteManagement/eventManager', eventManager)
    registerModule('app/resourcePlanningPM/projectComboSearch', projectComboSearch)    
}